/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Speech = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 17 20">
      <path
        d="M8.5,0.8584 C13.187,0.8584 17,4.2224 17,8.3584 C17,18.2064 9.119,18.9504 9.04,18.9564 L8.5,19.0004 L8.5,15.3584 C3.654,15.3584 0,12.3484 0,8.3584 C0,4.2224 3.813,0.8584 8.5,0.8584 Z M8.5,1.8584 C4.364,1.8584 1,4.7744 1,8.3584 C1,11.7794 4.225,14.3584 8.5,14.3584 L9.5,14.3584 L9.5,17.8754 C11.159,17.5354 16,15.8964 16,8.3584 C16,4.7744 12.636,1.8584 8.5,1.8584 Z"
        transform="translate(0 .142)"
      />
    </BaseSvgIcon>
  )
}

export default Speech
